module.exports = __webpack_public_path__ + "static/business-1be7da34afc6338e97f827377fddc8b1.jpg";